/*! react-radio v3.2.2 | (c) 2018 Trend Micro Inc. | MIT | https://github.com/trendmicro-frontend/react-radio */
module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 3);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _class, _temp2;

  var _classnames = __webpack_require__(4);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _index = __webpack_require__(5);

  var _index2 = _interopRequireDefault(_index);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var noop = function noop() {};

  var RadioButton = (_temp2 = _class = function (_PureComponent) {
    _inherits(RadioButton, _PureComponent);

    function RadioButton() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, RadioButton);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).call.apply(_ref, [this].concat(args))), _this), _this.radioButton = null, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RadioButton, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            label = _props.label,
            inputClassName = _props.inputClassName,
            inputStyle = _props.inputStyle,
            disabled = _props.disabled,
            _props$onChange = _props.onChange,
            onChange = _props$onChange === undefined ? noop : _props$onChange,
            className = _props.className,
            style = _props.style,
            children = _props.children,
            props = _objectWithoutProperties(_props, ['label', 'inputClassName', 'inputStyle', 'disabled', 'onChange', 'className', 'style', 'children']);

        return _react2.default.createElement('label', {
          className: (0, _classnames2.default)(className, _index2.default.controlRadio, _defineProperty({}, _index2.default.disabled, disabled)),
          style: style
        }, _react2.default.createElement('input', _extends({}, props, {
          ref: function ref(node) {
            _this2.radioButton = node;
          },
          type: 'radio',
          disabled: disabled,
          className: (0, _classnames2.default)(inputClassName, _index2.default.inputRadio),
          style: inputStyle,
          onChange: onChange
        })), _react2.default.createElement('i', {
          className: _index2.default.controlIndicator
        }), label ? _react2.default.createElement('span', {
          className: _index2.default.textLabel
        }, label) : null, children);
      }
    }, {
      key: 'checked',
      get: function get() {
        if (!this.radioButton) {
          return null;
        }

        return this.radioButton.checked;
      }
    }]);

    return RadioButton;
  }(_react.PureComponent), _class.propTypes = {
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    inputClassName: _propTypes2.default.object,
    inputStyle: _propTypes2.default.object,
    disabled: _propTypes2.default.bool,
    checked: _propTypes2.default.bool,
    defaultChecked: _propTypes2.default.bool,
    onChange: _propTypes2.default.func
  }, _class.defaultProps = {
    disabled: false
  }, _temp2);
  exports.default = RadioButton;
  /***/
},
/* 1 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
},
/* 2 */

/***/
function (module, exports) {
  module.exports = require("prop-types");
  /***/
},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.RadioGroup = exports.RadioButton = undefined;

  var _RadioButton2 = __webpack_require__(0);

  var _RadioButton3 = _interopRequireDefault(_RadioButton2);

  var _RadioGroup2 = __webpack_require__(6);

  var _RadioGroup3 = _interopRequireDefault(_RadioGroup2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.RadioButton = _RadioButton3.default;
  exports.RadioGroup = _RadioGroup3.default;
  /***/
},
/* 4 */

/***/
function (module, exports) {
  module.exports = require("classnames");
  /***/
},
/* 5 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "control-radio": "radio---control-radio---2rwkY",
    "controlRadio": "radio---control-radio---2rwkY",
    "disabled": "radio---disabled---eCY9b",
    "control-indicator": "radio---control-indicator---dcwXW",
    "controlIndicator": "radio---control-indicator---dcwXW",
    "input-radio": "radio---input-radio---2yM_b",
    "inputRadio": "radio---input-radio---2yM_b"
  };
  /***/
},
/* 6 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _class, _temp2;

  var _chainedFunction = __webpack_require__(7);

  var _chainedFunction2 = _interopRequireDefault(_chainedFunction);

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _RadioButton = __webpack_require__(0);

  var _RadioButton2 = _interopRequireDefault(_RadioButton);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var getComponentType = function getComponentType(Component) {
    return Component ? _react2.default.createElement(Component, null).type : undefined;
  };

  var RadioGroup = (_temp2 = _class = function (_PureComponent) {
    _inherits(RadioGroup, _PureComponent);

    function RadioGroup() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, RadioGroup);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
      }, _this.handleChange = function (value, event) {
        if (_this.props.value !== undefined) {
          // Controlled component
          _this.setState({
            value: _this.props.value
          });
        } else {
          // Uncontrolled component
          _this.setState({
            value: value
          });
        }

        if (typeof _this.props.onChange === 'function') {
          _this.props.onChange(value, event);
        }
      }, _this.renderChildren = function (children) {
        var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        if (depth > _this.props.depth) {
          return children;
        }

        var mapChild = function mapChild(child) {
          if (!_react2.default.isValidElement(child) || !child.props) {
            return child;
          }

          if (child.type === getComponentType(RadioGroup)) {
            // No nested radio groups
            return child;
          }

          if (child.type === getComponentType(_RadioButton2.default)) {
            return (0, _react.cloneElement)(child, {
              checked: _this.state.value !== undefined && _this.state.value === child.props.value,
              disabled: _this.props.disabled || child.props.disabled,
              onChange: (0, _chainedFunction2.default)(child.props.onChange, function (event) {
                _this.handleChange(child.props.value, event);
              })
            });
          }

          if (child.props.children && _typeof(child.props.children) === 'object') {
            return (0, _react.cloneElement)(child, {
              children: _this.renderChildren(child.props.children, depth + 1)
            });
          }

          return child;
        };

        if (Array.isArray(children)) {
          return _react2.default.Children.map(children, mapChild);
        } else {
          return mapChild(children);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RadioGroup, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.value !== undefined) {
          this.setState({
            value: nextProps.value
          });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return this.renderChildren(this.props.children);
      }
    }, {
      key: 'value',
      get: function get() {
        return this.state.value;
      }
    }]);

    return RadioGroup;
  }(_react.PureComponent), _class.propTypes = {
    disabled: _propTypes2.default.bool,
    name: _propTypes2.default.string,
    value: _propTypes2.default.any,
    defaultValue: _propTypes2.default.any,
    onChange: _propTypes2.default.func,
    depth: _propTypes2.default.number
  }, _class.defaultProps = {
    disabled: false,
    depth: 1
  }, _temp2);
  exports.default = RadioGroup;
  /***/
},
/* 7 */

/***/
function (module, exports) {
  module.exports = require("chained-function");
  /***/
}
/******/
]);